import { Box } from "@mui/material";

export default function StackedOverrideCell({
  original,
  override,
  overrideColor = "primary.main",
  fontStyle = "normal",
}: {
  original: string;
  override?: string;
  overrideColor?: string;
  fontStyle?: "bold" | "normal";
}) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", }}>
      <Box>{original}</Box>
      {override && (
        <Box sx={{ color: overrideColor, fontWeight: fontStyle === "bold" ? "600" : "normal" }}>{override}</Box>
      )}
    </Box>
  );
}
